export const ru = {
    early_departures_first: 'Сначала раннее отправление',
    economical_first: 'Сначала экономичные',
    expensive_first: 'Сначала дорогие',
    fast_first: 'Сначала быстрые',
    late_departures_first: 'Сначала позднее отправление',
    optimal_hotel: 'Оптимальные (корпоративные и рекомендованные)',
    optimal_train_flight: 'Оптимальные (по цене, длительности)',
};
